export default __webpack_public_path__ + "static/media/whitev3.391e30e2.png";